import { from, of, throwError, timer } from 'rxjs';
import { mergeMap, retryWhen, switchMap } from 'rxjs/operators';

import { ApiError, CreateOrderDto, OrderType, TradingGatewayApiClient } from 'common/api/autogenerated/trading-gateway';

const tradingGatewayApiClient = new TradingGatewayApiClient({
  BASE: '/trading-gateway',
  WITH_CREDENTIALS: true,
});

export const createOrderWithRetriesForMarket = (params: CreateOrderDto) => {
  if (params.type === OrderType.MARKET) {
    return of(null)
      .pipe(
        switchMap(() => from(tradingGatewayApiClient.spotTrading.postV1SpotOrders(params))),
        retryWhen((attempts) =>
          attempts.pipe(
            mergeMap((error: ApiError, attempt) => {
              const ATTEMPTS_TIMES = 25; // we need to recall api during 30sec, take a little less because we also have connection time-losses
              if (error?.body?.code?.includes?.('not-enough-money') && attempt < ATTEMPTS_TIMES) {
                return timer(1000);
              }
              return throwError(error);
            }),
          ),
        ),
      )
      .toPromise();
  }

  return tradingGatewayApiClient.spotTrading.postV1SpotOrders(params);
};

export const getCustomerCommissions = () => tradingGatewayApiClient.spotTrading.getV1SpotCustomerCommissions();
